import React from 'react';
import { Alert } from '@mui/material';

const NoPrivilege = ({ message }) => (
    <Alert severity="error" sx={{ mt: 4, fontSize: '1.3rem', textAlign: 'center', py: 4 }}>
        {message || 'You do not have permission to view this page.'}
    </Alert>
);

export default NoPrivilege; 